'use client';

import React from 'react';

type Props = {
    reportLink?: boolean;
    userVoteFromStand?: number;
    userVoteFromWeb?: number;
    setIsShowedUserVoteList?: (isShowed: boolean) => void;
};

const VotesReports = (props: Props) => {
    const {
        reportLink = false,
        userVoteFromStand = 0,
        userVoteFromWeb = 0,
        setIsShowedUserVoteList = () => {},
    } = props;
    const classNamesLink = 'text-[#83ab34] visited:text-[#83ab34]';

    const handleVoteClick = (event: React.MouseEvent) => {
        event.preventDefault();
        setIsShowedUserVoteList(true);
    };

    const VoteFromStandText = () => (
        <>
            <span className="font-bold">{userVoteFromStand}</span> innleverte stemmesedler fra stand
        </>
    );

    return (
        <div className="vote-report mb-4">
            <div className="flex flex-col lg:flex-row">
                <div className="w-[70%] lg:mb-0">
                    <ul className="leading-[1.75]">
                        <li>
                            <span className="font-bold">{userVoteFromWeb}</span> innleverte stemmesedler fra WEB
                        </li>
                        <li>
                            {reportLink ? (
                                <a href={'/'} className={classNamesLink} onClick={handleVoteClick}>
                                    <VoteFromStandText />
                                </a>
                            ) : (
                                <VoteFromStandText />
                            )}
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default VotesReports;
